<div id="dashboard-analytics" class="page-layout blank grey-100-bg">
  <h1>Dashboard</h1>
  <div class="filters fx-row fx-wrap fx-sm-column fx-sm-wrap fx-xs-column fx-xs-wrap" style="gap: 70px">
    <div class="departures fx-column">
      <form-input-viewer [formInputDefinition]='fileterFields.get("departure_date_from")' [formGroup]='filterFormGroup' formControlKey='departure_date_from' class="fx-flex"></form-input-viewer>
      <form-input-viewer [formInputDefinition]='fileterFields.get("departure_date_to")' [formGroup]='filterFormGroup' formControlKey='departure_date_to' class="fx-flex"></form-input-viewer>
    </div>

    <div class="bookings fx-column">
      <form-input-viewer [formInputDefinition]='fileterFields.get("booking_date_from")' [formGroup]='filterFormGroup' formControlKey='booking_date_from' class="fx-flex"></form-input-viewer>
      <form-input-viewer [formInputDefinition]='fileterFields.get("booking_date_to")' [formGroup]='filterFormGroup' formControlKey='booking_date_to' class="fx-flex"></form-input-viewer>
    </div>

    <!-- Resource -->
    <!--<mat-form-field class="filter-chip-list" >
    <mat-chip-grid #chip aria-label="Resource selection">
      <mat-chip-row
        *ngFor="let tripResource of dashboardService.filterResource"
        [selectable]="true"
        [removable]="true"
        (removed)="removeResource(tripResource.id)">
        {{ tripResource.description }}
        <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
      </mat-chip-row>
      <input #ResourceInput
        placeholder="Filtra risorse..."
        (input)="resourceFilteredOptions($event.target.value)"
        [formControl]="resourceCtrl"
        [matAutocomplete]="autores"
        [matChipInputFor]="chip"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addResource($event)">
    </mat-chip-grid>
    <mat-autocomplete
      #autores="matAutocomplete"
      (optionSelected)="onSelectResource($event)">
      <mat-option
        *ngFor="let option of resourceOptions | async"
        [value]="option">
        {{ option.description }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>-->
  <!--end Resource-->

  <div class="trip_package_categories fx-column">
    <!--Package-->
    <form-input-viewer [formInputDefinition]='fileterFields.get("package_code")' [formGroup]='filterFormGroup' formControlKey='package_code' class="fx-flex"></form-input-viewer>
    <!--end Package-->
    <!-- Category -->
    <form-input-viewer [formInputDefinition]='fileterFields.get("category_id")' [formGroup]='filterFormGroup' formControlKey='category_id' class="fx-flex"></form-input-viewer>
    <!--end Category-->
  </div>

  <div class="customers_branches fx-column">
    <!-- start Customer -->
    <form-input-viewer [formInputDefinition]='fileterFields.get("customer_code")' [formGroup]='filterFormGroup' formControlKey='customer_code' class="fx-flex"></form-input-viewer>
    <!--end Customer-->
    <!-- start branch-->
    <form-input-viewer [formInputDefinition]='fileterFields.get("branch_code")' [formGroup]='filterFormGroup' formControlKey='branch_code' class="fx-flex"></form-input-viewer>
    <!--end branch-->
  </div>
</div>

<div class="filters_mobile">
  <button mat-button color="accent" (click)='openFilters()'>
    <mat-icon>launch</mat-icon>
    {{'Filtra' | translate}}
    @if (numFilters) {
      <span class="num_filters">({{numFilters}} {{numFilters > 1 ? 'Filtri Attivi' : 'Filtro Attivo'}})</span>
    }
  </button>
</div>

<div class="grid-container fx-column fx-justify-start fx-items-stretch">
  <div class="fx-row fx-sm-column fx-xs-column">
    @if (dashboardService.enabledStats.includes('traveldate')) {
      <div class="grid-item fx-flex-50">
        <!-- Widget 1-->
        <div class="fuse-card auto-width px-8 fx-gt-sm-mb0-mr10">
          <div class="title_chart">
            <h2>{{'Entrate per data di viaggio' | translate}}</h2>
            <div class="line"></div>
          </div>
          <traveldate></traveldate>
        </div>
        <!-- / widget 1 -->
      </div>
    }

    @if (dashboardService.enabledStats.includes('checkoutdate')) {
      <div class="grid-item fx-flex-50">
        <!-- Widget 2-->
        <div class="fuse-card auto-width px-8">
          <div class="title_chart">
            <h2>{{'Entrate per data di checkout' | translate}}</h2>
            <h3>{{'Ricavi per mese di checkout' | translate}}</h3>
            <div class="line"></div>
          </div>
          <checkoutdate></checkoutdate>
        </div>
        <!-- / widget 2-->
      </div>
    }
  </div>

  <div class="fx-row fx-justify-start fx-items-stretch fx-sm-column fx-xs-column">
    @if (dashboardService.enabledStats.includes('ticket')) {
      <div class="grid-item fx-flex-50">
        <!-- Widget 3-->
        <div class="fuse-card auto-width px-8">
          <div class="title_chart">
            <h2>{{'Biglietti' | translate}}</h2>
            <h3>{{'Biglietti per mese di viaggio' | translate}}</h3>
            <div class="line"></div>
          </div>
          <ticket></ticket>
        </div>
        <!-- / widget 3-->
      </div>
    }

    <div class="fx-flex-50 fx-row fx-justify-start fx-items-stretch fx-sm-column fx-xs-column">
      <!-- Widget 4-->
      @if (dashboardService.enabledStats.includes('ticketsyear')) {
        <div class="grid-item fx-flex-50">
          <div class="fuse-card auto-width mb-48">
            <div class="title_chart">
              <h2>{{'Biglietti' | translate}}</h2>
              <h3>{{'Biglietti per anno di viaggio' | translate}}</h3>
              <div class="line"></div>
            </div>
            <ticketsyear></ticketsyear>
          </div>
        </div>
      }
      <!-- / widget 4-->
      <!-- Widget 5-->
      @if (dashboardService.enabledStats.includes('revenue')) {
        <div class="grid-item fx-flex-50">
          <div class="fuse-card auto-width mb-48">
            <div class="title_chart">
              <h2>{{'Reddito' | translate}}</h2>
              <h3>{{'Ricavi per anno di viaggio' | translate}}</h3>
              <div class="line"></div>
            </div>
            <revenue></revenue>
          </div>
        </div>
      }
      <!-- / widget 5-->
    </div>
  </div>

  <div class="fx-row fx-justify-start fx-items-stretch fx-sm-column fx-xs-column">
    @if (dashboardService.enabledStats.includes('bookingwindow')) {
      <div class="grid-item fx-flex-50">
        <!-- Widget 6-->
        <div class="fuse-card auto-width px-8">
          <div class="title_chart">
            <h2>{{'Finestra di prenotazione' | translate}}</h2>
            <h3>{{'Giorni dalla prenotazione alla data di conduzione (inferiore a 1 significa prenotazione lo stesso giorno)' | translate}}</h3>
            <div class="line"></div>
          </div>
          <bookingwindow></bookingwindow>
        </div>
        <!-- / widget 6-->
      </div>
    }

    @if (dashboardService.enabledStats.includes('sourcemarkets')) {
      <div class="grid-item fx-flex-50">
        <!-- Widget 7-->
        <div class="fuse-card auto-width px-8">
          <div class="title_chart">
            <h2>{{'Mercati di origine' | translate}}</h2>
            <h3>{{'Primi 10 mercati di origine per entrate (per data di checkout)' | translate}}</h3>
            <div class="line"></div>
          </div>
          <sourcemarkets></sourcemarkets>
        </div>
        <!-- / widget 7-->
      </div>
    }
  </div>

  <div class="fx-row fx-justify-start fx-items-stretch fx-sm-column fx-xs-column">
    @if (dashboardService.enabledStats.includes('reviews')) {
      <div class="grid-item fx-flex-50">
        <!-- Widget 8-->
        <div class="fuse-card auto-width px-8">
          <div class="title_chart">
            <h2>{{'Recensioni' | translate}}</h2>
            <h3>{{'Valutazione media e di recensioni negative per mese di revisione' | translate}}</h3>
            <div class="line"></div>
          </div>
          <reviews></reviews>
        </div>
        <!-- / widget 8-->
      </div>
    }

    @if (dashboardService.enabledStats.includes('reviewsstat')) {
      <div class="grid-item fx-flex-50">
        <!-- Widget 9-->
        <div class="fuse-card auto-width px-8">
          <div class="title_chart">
            <h2>{{'Recensioni' | translate}}</h2>
            <h3>{{'Valutazione media e recensioni negative totali per anno di revisione' | translate}}</h3>
            <div class="line"></div>
          </div>
          <reviewsystat></reviewsystat>
        </div>
        <!-- / widget 9-->
      </div>
    }
  </div>
</div>
</div>